<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="1200px"
    scrollable
    persistent
  >
    <v-card class="application-modal elevation-12">
      <!-- Header mejorado -->
      <v-card-title class="header-gradient white--text pa-3 d-flex align-center">
        <div class="d-flex align-center">
          <v-avatar size="32" class="mr-3 white--text" style="background: rgba(255,255,255,0.2);">
            <v-icon dark>mdi-spray</v-icon>
          </v-avatar>
          <div>
            <div class="text-h6 mb-0">{{ isEdit ? 'Editar' : 'Nueva' }} Aplicación</div>
            <div class="caption" style="opacity: 0.9;">Gestión de aplicaciones agrícolas</div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeModal" class="hover-close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-form ref="form" v-model="valid">
          <!-- Sección de agregar detalles - Mejorada -->
          <v-card flat class="detail-input-section">
            <v-card-subtitle class="section-header d-flex align-center pa-3">
              <v-icon color="primary" class="mr-2">mdi-plus-circle</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Agregar Detalle</span>
              <v-spacer></v-spacer>
              <v-chip
                small
                :color="isObservationMode ? 'orange' : 'blue'"
                text-color="white"
                class="ml-2"
              >
                {{ isObservationMode ? 'Observación' : 'Producto' }}
              </v-chip>
            </v-card-subtitle>
            
            <v-card-text class="pa-3">
              <v-row dense>
                <!-- Switch modo observación -->
                <v-col cols="12" md="2" class="pb-0">
                  <v-switch
                    v-model="isObservationMode"
                    label="Modo Observación"
                    color="primary"
                    dense
                    hide-details
                    @change="resetDetailForm"
                    class="mt-0"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <!-- Producto o Observación -->
                <v-col cols="12" md="4">
                  <s-textarea
                    v-if="isObservationMode"
                    label="Observación*"
                    v-model="detailForm.observation"
                    :rules="observationRules"
                    rows="2"
                    outlined
                    dense
                    hide-details="auto"
                  />
                  <s-select-listsupplies
                    v-else
                    label="Producto*"
                    v-model="detailForm.product"
                    :rules="productRules"
                    :PlID="0"
                    :TypeCultive="typeCultive"
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                    @input="onProductChange"
                  />
                </v-col>

                <!-- Tipo de Aplicación -->
                <v-col cols="12" md="3">
                  <s-select-definition
                    label="Tipo*"
                    v-model="detailForm.applicationType"
                    :rules="applicationTypeRules"
                    :def="1360"
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              
                <!-- Dosis -->
                <v-col cols="6" md="2">
                  <s-text
                    label="Dosis*"
                    v-model="detailForm.dose"
                    :rules="doseRules"
                    decimal
                    :min="0"
                    outlined
                    dense
                    hide-details="auto"
                    @input="onDoseChange"
                  />
                </v-col>

                <!-- Cantidad Total -->
                <v-col cols="6" md="2">
                  <s-text
                    label="Cantidad Total*"
                    v-model="detailForm.totalAmount"
                    :rules="totalAmountRules"
                    decimal
                    :maxDecimal="3"
                    :min="0"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>

                <!-- Botón agregar mejorado -->
                <v-col cols="12" md="1" class="d-flex align-center">
                  <v-btn
                    fab
                    color="success"
                    small
                    @click="addDetail"
                    :disabled="!isDetailFormValid"
                    class="add-detail-btn"
                    elevation="2"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Tabla de detalles mejorada -->
          <v-card flat class="details-table-section" v-if="applicationDetails.length > 0">
            <v-card-subtitle class="section-header d-flex align-center pa-3">
              <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Detalles Agregados</span>
              <v-spacer></v-spacer>
              <v-chip small color="primary" text-color="white">
                {{ applicationDetails.length }} {{ applicationDetails.length === 1 ? 'detalle' : 'detalles' }}
              </v-chip>
            </v-card-subtitle>
            
            <v-card-text class="pa-3">
              <v-data-table
                :items="applicationDetails.filter(item => item.SecStatus === 1)"
                :headers="detailHeaders"
                dense
                :items-per-page="5"
                no-data-text="No hay detalles agregados"
                class="modern-table"
                hide-default-footer
              >
                <template v-slot:[`item.Actions`]="{ item, index }">
                  <v-btn
                    @click="removeDetail(index)"
                    x-small
                    color="error"
                    text
                    class="delete-btn"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <!-- Formulario principal mejorado -->
          <v-card flat class="main-form-section">
            <v-card-subtitle class="section-header d-flex align-center pa-3">
              <v-icon color="primary" class="mr-2">mdi-file-document-edit</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Datos Generales</span>
            </v-card-subtitle>
            
            <v-card-text class="pa-3">
              <v-row dense>
                <v-col cols="12" md="6">
                  <s-select-definition
                    v-model="mainForm.TypeApplication"
                    :rules="typeApplicationRules"
                    clearable
                    :def="1361"
                    label="Tipo Aplicación*"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <s-select-definition
                    v-if="mainForm.TypeApplication === 2"
                    v-model="mainForm.TypeFocused"
                    :def="1515"
                    label="Focalizada"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
              
              <v-row dense class="mt-2">
                <v-col cols="12" md="6">
                  <s-date 
                    label="Fecha Inicio*" 
                    v-model="mainForm.PapDate"
                    :rules="dateRules"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <s-date 
                    label="Fecha Fin*" 
                    v-model="mainForm.PapDateEnd"
                    :rules="dateEndRules"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
              
              <v-row dense class="mt-2">
                <v-col cols="12" md="6" v-if="mainForm.TypeApplication === 1">
                  <s-text
                    label="Litros de Agua"
                    v-model="mainForm.PapLiterWater"
                    type="number"
                    step="0.001"
                    :min="0"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <s-text
                    label="Gasto combustible (Gal)"
                    v-model="mainForm.PapFuelExpense"
                    type="number"
                    step="0.001"
                    :min="0"
                    outlined
                    dense
                    hide-details="auto"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>

      <!-- Footer mejorado -->
      <v-card-actions class="action-footer pa-4">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          @click="closeModal"
          class="mr-3"
          color="grey darken-1"
        >
          <v-icon left small>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          @click="saveApplication"
          :disabled="!canSaveApplication"
          :loading="saving"
          elevation="2"
        >
          <v-icon left small>{{ isEdit ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
          {{ isEdit ? 'Actualizar' : 'Guardar' }} Aplicación
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import sSelectListsupplies from "@/components/TecnicalAssistence/ListSupplies/SSelectListsupplies";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "ApplicationModal",
  components: {
    sSelectListsupplies
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    applicationData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    typeCultive: {
      type: Number,
      default: 0
    },
    vstID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      numMultiplier: 3,
      valid: false,
      saving: false,
      isObservationMode: false,
      
      // Formulario para agregar detalles
      detailForm: {
        product: null,
        observation: "",
        applicationType: null,
        dose: null,
        totalAmount: null
      },
      
      // Formulario principal
      mainForm: {
        TypeApplication: 1,
        TypeFocused: null,
        PapDate: null,
        PapDateEnd: null,
        PapLiterWater: 200,
        PapFuelExpense: null
      },
      
      // Array de detalles
      applicationDetails: [],
      typeUnit: null,
      
      // Headers para la tabla de detalles
      detailHeaders: [
        { text: 'Línea', value: 'Line', width: '80px' },
        { text: 'Producto', value: 'LsName' },
        { text: 'Observaciones', value: 'PpaObservation' },
        { text: 'Tipo', value: 'TypeApplicationName' },
        { text: 'Dosis', value: 'PpaDose' },
        { text: 'Cantidad', value: 'AmountTotal' },
        { text: 'Acciones', value: 'Actions', align: 'center', width: '90px', sortable: false }
      ],
      
      // Reglas de validación para detalles
      productRules: [
        v => !!v || 'El producto es requerido'
      ],
      observationRules: [
        v => !!v || 'La observación es requerida'
      ],
      applicationTypeRules: [
        v => !!v || 'El tipo de aplicación es requerido'
      ],
      doseRules: [
        v => !!v || 'La dosis es requerida',
        v => v > 0 || 'La dosis debe ser mayor a 0'
      ],
      totalAmountRules: [
        v => !!v || 'La cantidad total es requerida',
        v => v > 0 || 'La cantidad total debe ser mayor a 0'
      ],
      
      // Reglas para formulario principal
      typeApplicationRules: [
        v => !!v || 'El tipo de aplicación es requerido'
      ],
      dateRules: [
        v => !!v || 'La fecha de inicio es requerida'
      ],
      dateEndRules: [
        v => !!v || 'La fecha de fin es requerida'
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    
    isDetailFormValid() {
      if (this.isObservationMode) {
        return this.detailForm.observation && 
               this.detailForm.applicationType && 
               this.detailForm.dose > 0 && 
               this.detailForm.totalAmount > 0;
      } else {
        return this.detailForm.product && 
               this.detailForm.applicationType && 
               this.detailForm.dose > 0 && 
               this.detailForm.totalAmount > 0;
      }
    },
    
    canSaveApplication() {
      return this.applicationDetails.length > 0 &&
             this.applicationDetails.filter(x => x.SecStatus === 1).length > 0 && 
             this.mainForm.TypeApplication && 
             this.mainForm.PapDate && 
             this.mainForm.PapDateEnd &&
             this.valid;
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.initializeForm();
      }
    },
    applicationData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.loadApplicationData(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initializeForm() {
      if (this.isEdit && this.applicationData) {
        this.loadApplicationData(this.applicationData);
      } else {
        this.resetForm();
      }
    },
    
    loadApplicationData(data) {
      // Cargar formulario principal
      this.mainForm = {
        TypeApplication: data.TypeApplication || null,
        TypeFocused: data.TypeFocused || null,
        PapDate: data.PapDate || null,
        PapDateEnd: data.PapDateEnd || null,
        PapLiterWater: data.PapLiterWater || null,
        PapFuelExpense: data.PapFuelExpense || null,
        UUID: data.UUID || null
      };
      
      // Cargar detalles si existen
      if (data.TasVisitProductApplications && data.TasVisitProductApplications.length > 0) {
        this.applicationDetails = data.TasVisitProductApplications
          .filter(detail => detail.SecStatus === 1)
          .map((detail, index) => ({
            ...detail,
            Line: index + 1
          }));
      }
    },
    
    resetForm() {
      this.detailForm = {
        product: null,
        observation: "",
        applicationType: null,
        dose: null,
        totalAmount: null
      };
      
      this.mainForm = {
        TypeApplication: 1,
        TypeFocused: null,
        PapDate: null,
        PapDateEnd: null,
        PapLiterWater: 200,
        PapFuelExpense: null
      };
      
      this.applicationDetails = [];
      this.typeUnit = null;
      this.isObservationMode = false;
      
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    
    resetDetailForm() {
      this.detailForm = {
        product: null,
        observation: "",
        applicationType: null,
        dose: null,
        totalAmount: null
      };
      this.typeUnit = null;
    },
    
    onProductChange(product) {
      if (product) {
        this.typeUnit = {
          DedValue: product.LsUnitID,
          DedDescription: product.DedDescription
        };
      } else {
        this.typeUnit = null;
      }
    },
    
    addDetail() {
      if (!this.isDetailFormValid) {
        return;
      }
      
      const detail = {
        Line: this.applicationDetails.length + 1,
        LsID: this.isObservationMode ? null : this.detailForm.product.LsID,
        LsName: this.isObservationMode ? "" : this.detailForm.product.LsDescription,
        PpaObservation: this.isObservationMode ? this.detailForm.observation : "",
        TypeAplication: this.detailForm.applicationType.DedValue,
        TypeApplicationName: this.detailForm.applicationType.DedDescription,
        PpaDose: this.detailForm.dose,
        AmountTotal: this.detailForm.totalAmount,
        TypeUnit: this.typeUnit ? this.typeUnit.DedValue : null,
        TypeUnitName: this.typeUnit ? this.typeUnit.DedDescription : "",
        SecStatus: 1,
        PpaID: 0, // Nuevo registro
        UUID:uuidv4()
      };
      
      this.applicationDetails.push(detail);
      this.resetDetailForm();
      
      this.$fun.alert("Detalle agregado correctamente", "success");
    },
    
    removeDetail(index) {
      console.log(index);
      this.applicationDetails[index].SecStatus = 0;
      console.log(this.applicationDetails);
      this.reorderDetails();
    },
    
    reorderDetails() {
      let line = 1;
      this.applicationDetails.forEach(item => {
        if (item.SecStatus === 1) {
          item.Line = line++;
        }
      });
    },
    
    saveApplication() {
      if (!this.$refs.form.validate() || !this.canSaveApplication) {
        return;
      }
      
      this.saving = true;
      
      try {
        const applicationData = {
          ...this.mainForm,
          VstID: this.vstID,
          SecStatus: 1,
          TasVisitProductApplications: this.applicationDetails,
          SecUpdate: this.isEdit ? this.$fun.getDateTimeShortDB() : null,
          PapID: this.isEdit ? this.applicationData.PapID : 0,
          UsrCreateID: this.$fun.getUserID(),
          UUID:this.isEdit ?this.applicationData.UUID:uuidv4()
        };
        
        this.$emit('saved', applicationData);
        this.closeModal();
      } catch (error) {
        console.error("Error al guardar aplicación:", error);
        this.$fun.alert("Error al guardar la aplicación", "error");
      } finally {
        this.saving = false;
      }
    },
    
    closeModal() {
      this.dialogVisible = false;
      this.resetForm();
      this.$emit('close');
    },

    onDoseChange(value) {
      // Multiplica la dosis por 3 y actualiza el campo cantidad total
      const dose = parseFloat(value) || 0;
      this.detailForm.totalAmount = dose * this.numMultiplier;
    },
  }
};
</script>

<style scoped>
.application-modal {
  border-radius: 12px !important;
}

.header-gradient {
  background: linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%);
  border-radius: 12px 12px 0 0 !important;
}

.hover-close:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.detail-input-section {
  border-bottom: 1px solid #e0e0e0;
}

.details-table-section {
  border-bottom: 1px solid #e0e0e0;
}

.main-form-section {
  background: #fafafa;
}

.section-header {
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.add-detail-btn {
  transition: all 0.3s ease;
}

.add-detail-btn:hover {
  transform: scale(1.05);
}

.modern-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-table ::v-deep .v-data-table__wrapper {
  border-radius: 8px;
}

.modern-table ::v-deep th {
  background: #f8f9fa !important;
  font-weight: 600 !important;
  color: #495057 !important;
}

.modern-table ::v-deep tr:hover {
  background: #f8f9fa !important;
}

.delete-btn {
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background: rgba(244, 67, 54, 0.1) !important;
}

.action-footer {
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  /* .application-modal {
    margin: 12px;
  } */
  
  .section-header {
    padding: 12px 16px !important;
  }
  
  .v-card-text {
    padding: 12px 16px !important;
  }
}</style>